import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import scss from './FieldValues.module.scss';

function FieldValues({ fieldValues }) {
  const { t } = useTranslation('studio');

  const formattedFieldValues = useMemo(() => {
    return Object.entries(fieldValues)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        return {
          key,
          value: value?.label ?? value,
        };
      });
  }, [fieldValues]);

  if (formattedFieldValues.length === 0) {
    return null;
  }

  return (
    <div className={scss.wrapper}>
      {formattedFieldValues.map(({ key, value }) => (
        <div key={key} className={scss.fieldValue}>
          <span className={scss.fieldKey}>{t(key)}:</span>
          <span className={scss.fieldValueText}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default FieldValues;
